import React from 'react';
import styles from './FilterWrapper.module.scss';

import clsx from 'clsx';

export default function FilterWrapper({ className, children }) {
  return <div className={clsx(className && className, styles.wrapper)}>{children}</div>;
}
